export const INDUSTRIES = [
  "Technology",
  "Business",
  "Cloud",
  "SaaS",
  "Food and Beverage",
  "Travel",
  "Education",
  "Health and Wellness",
  "Fashion",
  "Beauty",
  "Sports",
  "Gaming",
  "Pets",
  "Entertainment",
  "Lifestyle",
  "Home and Garden"

];

export const POPULAR_BRAND_CHANNEL = [{
platform:"Instagram",
icon:"instagram.png",
audience:"2B+",
engagementRate:"4.9%",
popularFormate:["Short Form Video", "Static Image Posts"],
growthRate:"5.7%"
},{
  platform:"TikTok",
  audience:"1.5B+",
  engagementRate:"3.2%",
  popularFormate:["Short Form Video"],
  growthRate:"6.7%",
  icon:"tiktok-big.png"
  },{
    platform:"YouTube",
    audience:" 2.5B+",
    engagementRate:"2%",
    popularFormate:["Short and Long Form Video"],
    growthRate:" 4.8%",
    icon:"youtube-big.png"
    },{
      platform:"LinkedIn",
      audience:"800M+",
      engagementRate:"2.5%",
      popularFormate:["Text-Based", "Static Image Posts"],
      growthRate:"3.2%",
      icon:"linkedin-big.png"
      },{
        platform:"X",
        audience:"600M+",
        engagementRate:"2.2%",
        popularFormate:["Text-Based Posts"],
        growthRate:"6%",
        icon:"twitter-big.png"
        }];

export const BRAND_CONTENT_FORMATE = [{
  title:"Shorts Form Video",
  platforms:["instagram", "tiktok", "youtube", "facebook"],
  engagementRate:"High",
  icon:"trending/video-replay.png",
},
{
  title:"Carousel Image Posts",
  platforms:["instagram", "linkedin", "facebook"],
  engagementRate:"Medium",
  icon:"trending/gallery.png",
},
{
  title:"Long Form Video",
  platforms:["youtube"],
  engagementRate:"Medium",
  icon:"trending/video-replay.png",
},
{
  title:"Single Image Posts",
  platforms:["instagram","facebook","linkedin","twitter"],
  engagementRate:"High",
  icon:"trending/gallery.png",
},
{
  title:"Text Based Content",
  platforms:["linkedin","twitter"],
  engagementRate:"Medium",
  icon:"trending/text.png"
},
]

export const TRENDING_AUDIO = [
{
  title: "Chai and Sunshine - Anjulie Music",
  link: "https://www.instagram.com/reels/audio/2848991201917030?igsh=MXd0NWY0YmI1MmVuOA==",
  posts: "119k+",
  platforms: ["instagram","facebook", "youtube"]
}, {
  title: "Peekaboo - Kendrick Lamar",
  link: "https://www.instagram.com/reels/audio/587468330316800?igsh=MWVkdXcxMWt0YWltYw==",
  posts: "94k+",
  platforms: ["instagram","facebook", "youtube"]
}, {
  title: "Chest Pain (I love) - Malcolm Todd",
  link: "https://www.instagram.com/reels/audio/558783933558902?igsh=MWU4ZnAzYWRtdHBkMQ==",
  posts: "252k+",
  platforms: ["instagram","facebook", "youtube"]
}, {
  title: "Something beautiful - Lucky Reinhard",
  link: "https://www.instagram.com/reels/audio/472063841868951?igsh=dXYzNjQ2cGkycWF5",
  posts: "62k+",
  platforms: ["instagram","facebook", "youtube"]
}, {
  title: "Day Tripper - The spacemen",
  link: "https://www.instagram.com/reels/audio/324343458213123?igsh=azZya2thN3I5ampm",
  posts: "50k+",
  platforms: ["instagram","facebook", "youtube"]
}, {
  title: "Levels - Avicii",
  link: "https://www.instagram.com/reels/audio/1143017525847524?igsh=MWd4d2liYnJsMmE3Yg==",
  posts: "190k+",
  platforms: ["instagram","facebook", "youtube"]
}, {
  title: "Round and Round",
  link: "https://www.instagram.com/reels/audio/1190794695923340?igsh=dHpqdTdlZm14cmdx",
  posts: "74k+",
  platforms: ["instagram","facebook", "youtube"]
}, {
  title: "Go Season - Music by Milano",
  link: "https://www.instagram.com/reels/audio/957287078116179?igsh=NDh4OGRtcXQ1c2l0",
  posts: "22k+",
  platforms: ["instagram","facebook", "youtube"]
}, {
  title: "Chillin - Wale",
  link: "https://www.instagram.com/reels/audio/352999918901219?igsh=MjM0N25zMjRjZ2Rx",
  posts: "38k+",
  platforms: ["instagram","facebook", "youtube"]
}, 
]

export const TRENDING_HASHTAG = [{
  hashtag: "#love",
  platforms: ["instagram", "tiktok", "twitter"],
  post: ""
},
{
  hashtag: "#tariffs",
  platforms: ["youtube", "twitter", "instagram", "tiktok", "linkedin"],
  post: ""
},
{
  hashtag: "#fashion",
  platforms: ["instagram", "twitter"],
  post: ""
},
{
  hashtag: "#photooftheday",
  platforms: ["instagram"],
  post: ""
},
{
  hashtag: "#photography",
  platforms: ["instagram"],
  post: ""
},
{
  hashtag: "#art",
  platforms: ["instagram"],
  post: ""
},
{
  hashtag: "#beautiful",
  platforms: ["instagram"],
  post: ""
},
{
  hashtag: "#nature",
  platforms: ["instagram"],
  post: ""
},
{
  hashtag: "#picoftheday",
  platforms: ["instagram"],
  post: ""
},
{
  hashtag: "#happy",
  platforms: ["instagram"],
  post: ""
},
{
  hashtag: "#fyp",
  platforms: ["tiktok"],
  post: ""
},
{
  hashtag: "#tiktok",
  platforms: ["tiktok"],
  post: ""
},
{
  hashtag: "#foryoupage",
  platforms: ["tiktok"],
  post: ""
},
{
  hashtag: "#viralvideos",
  platforms: ["tiktok"],
  post: ""
},
{
  hashtag: "#foryou",
  platforms: ["tiktok"],
  post: ""
},
{
  hashtag: "#funnyvideos",
  platforms: ["tiktok"],
  post: ""
},
{
  hashtag: "#trending",
  platforms: ["tiktok"],
  post: ""
}, {
  hashtag: "#viral",
  platforms: ["tiktok"],
  post: ""
}, {
  hashtag: "#followme",
  platforms: ["tiktok"],
  post: ""
}, {
  hashtag: "#comedy",
  platforms: ["youtube"],
  post: ""
}, {
  hashtag: "#shorts",
  platforms: ["youtube"],
  post: ""
}, {
  hashtag: "#shortsvideo",
  platforms: ["youtube"],
  post: ""
}, {
  hashtag: "#fitness",
  platforms: ["youtube"],
  post: ""
}, {
  hashtag: "#vlog",
  platforms: ["youtube"],
  post: ""
}, {
  hashtag: "#tech",
  platforms: ["youtube", "linkedin", "twitter"],
  post: ""
}, {
  hashtag: "#gaming",
  platforms: ["youtube"],
  post: ""
}, {
  hashtag: "#food",
  platforms: ["youtube", "twitter", "instagram", "tiktok"],
  post: ""
}, {
  hashtag: "#travel",
  platforms: ["youtube", "twitter", "instagram"],
  post: ""
}, {
  hashtag: "#beauty",
  platforms: ["youtube", "instagram", "tiktok"],
  post: ""
}, {
  hashtag: "#innovation",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#management",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#humanresources",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#digitalmarketing",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#technology",
  platforms: ["linkedin", "twitter"],
  post: ""
}, {
  hashtag: "#creativity",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#future",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#futurism",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#entreprenuership",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#careers",
  platforms: ["linkedin"],
  post: ""
}, {
  hashtag: "#news",
  platforms: ["twitter"],
  post: ""
}, {
  hashtag: "#sports",
  platforms: ["twitter"],
  post: ""
}, {
  hashtag: "#health",
  platforms: ["twitter", "linkedin", "youtube"],
  post: ""
}, {
  hashtag: "#business",
  platforms: ["twitter", "linkedin"],
  post: ""
}, {
  hashtag: "#foodie",
  platforms: ["youtube", "instagram", "tiktok"],
  post: ""
}, {
  hashtag: "#follow",
  platforms: ["twitter", "youtube", "instagram", "tiktok"],
  post: ""
}
]

export const SOCIAL_LISTING = [{
  title: "In Beauty: Sabrina Carpenter Routine",
  description: "Content using Sabrina Carpenter's music is trending, and in the beauty industry, the Sabrina Carpenter beauty routine has spiked in viewership and engagement.",
  timeline: "July 2024",
  headerDesc: "Content using Sabrina Carpenter's music is trending, and in the...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "In Fashion and Apparel: OOTD & Fit Check",
  description: "Content showcasing multiple outfits is a trending theme. Especially content with summer outfit looks, using trending sounds on video.",
  timeline: "July 2024",
  headerDesc: "Content showcasing multiple outfits is a trending theme. Espec...",
  primaryChannel: ["instagram","tiktok"]

},
{
  title: "In Travel and Tourism: Summer travel",
  description: "Travel vlogs and summer destinations/activities is a trending topic. Content surrounding travel destinations, how-to's, story times, summer activities, and vlogs have high engagement this month.",
  timeline: "July 2024",
  headerDesc: "Travel vlogs and summer destinations/activities is a trend...",
  primaryChannel: ["instagram","tiktok","youtube"]
},
{
  title: "In Sports: 2024 Paris Olympics",
  description: "The Olympics is a top trending topic this month. Content featuring Olympics reviews, athletics, sports, and athlete/workout routines is a trending topic. Sub-topics that are trending around the Olympics are the comeback of Simone Biles and Celine Dion, with many praising both performances as legends in their respective fields. In Canada, Summer McIntosh’s performance is trending with her multiple gold medal wins at the Olympics. Discussion on the opening ceremony and inclusion of break dancing in the Olympics has sparked widespread discussion across social media with many weighing in their thoughts. Discussion on Paris as a travel destination is also trending, with Paris travel tips being a focus. Olympics-inspired content is also trending, with creators piggybacking on the Olympics theme to create content - for example, “If Olympics had a medal for [X] I would win”",
  timeline: "August 2024",
  headerDesc: "The Olympics is a top trending topic this month. Content...",
  primaryChannel: ["instagram","tiktok","youtube","linkedin"]
},
{
  title: "In Lifestyle: I’m Just a Girl",
  description: "There is a booming trend of creators and businesses sharing videos and carousel posts with the theme of “I’m just a girl”, particularly on Instagram and Tiktok. This content focuses on women's issues & trending topics. Both women and men are weighing in with their thoughts on this trend that features common characteristics of women, like wanting to shop & dress fashionably, always wanting a great picture, or taking a yoga class, and the audio/text featuring the “I’m just a girl” as the explanation. The content primarily focuses on inspirational or comedic takes. The trend I’m Just a Girl correlates to the larger topic of women’s issues, and many businesses have hoped onto this trend to showcase their products or brand messaging to help women. The trending audio Just a Girl by U Rock, is commonly used for this trend. This trend has also expanded into conversational lingo with many people now using the statement “I’m just a girl” to explain their daily choices.",
  timeline: "August 2024",
  headerDesc: "There is a booming trend of creators and businesses shar...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "In Fashion and Apparel: Paging Dr. Beat",
  description: "Content using the Paging Dr. Beat format has been going viral, with videos using this trending format gaining higher viewership and engagement. These videos focus on inspirational content, like outfit inspiration, recipe inspiration, business growth tips, and travel inspiration. From a business lens, we have seen companies showcasing their favorite products, or comedic/educational content around their business and team.",
  timeline: "August 2024",
  headerDesc: "Content using the Paging Dr. Beat format has been going...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Back to School",
  description: "Back to school is one of the hottest topics growing on social, with students and parents sharing their back-to-school essentials, outfits, meal prep, and more. Throughout August and September, the topics around back-to-school season will be a trending topic. Comedic posts surrounding back-to-school have been trending at this time, as well as teacher-focused content, and parent’s tips/views on back-to-school for their kids.",
  timeline: "August 2024",
  headerDesc: "Back to school is one of the hottest topics growing on ...",
  primaryChannel: ["instagram","tiktok", "youtube","linkedin"]
},
{
  title: "You and Me Always Forever",
  description: 'There is a booming trend of creators sharing video posts with this carousel format, primarily on Instagram and TikTok. The content features things that live in pairs and how they are always the best together. This trend features three frames in a carousel-style reel often centered around friendship, pairs/duo, and sibling content. The first carousel showcases one product/individual/animal with the on-screen text “You”, the second carousel showcases another product/individual/animal with the onscreen text “Me” and the final carousel features both doing something together with on-screen text "Always Forever". Businesses use this trend to feature their products as the perfect pair for individuals. You can commonly see this trend being shared among friends and siblings with a popular meme cat and meme hampster. This content has a high engagement rate, with individuals tagging their friends, or sharing the video to their community.',
  timeline: "August 2024",
  headerDesc: "There is a booming trend of creators sharing video pos...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Give Me 14 Of Them",
  description: "A video featuring an individual loving pancakes so much, that he wanted an extra 14 of them went viral. This video has sparked thousands of creators to use the trending audio to share comedic videos, or product endorsements for their business. Many creators have also integrated that viral video clip into their videos to share how amazing something is. This audio or video is currently trending and boosting viewership and engagement. From a brand lens, this audio can easily be used to share how amazing your product, brand, or messaging is.",
  timeline: "August 2024",
  headerDesc: "A video featuring an individual loving pancakes so mu...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "In Travel and Tourism: Family Fun and Nostalgia",
  description: "In August, Family and Nostalgia centered content is trending. This month family travel is a big topic with many heading out for vacation this month, especially around the long weekends across North America. Video content surrounding family travel ideas, family-focused comedy, family recipe favorites, family dynamics etc. is trending. From a business lens, family-focused social content is winning.",
  timeline: "August 2024",
  headerDesc: "In August, Family and Nostalgia centered content is...",
  primaryChannel: ["instagram","tiktok", "youtube"]
},
{
  title: "Politics",
  description: "Discussion on the political landscape has exponentially grown in engagement and viewership. In particular, the US political landscape is a current hot topic on social, with many creators weighing in their thoughts on the Trump vs. Harris campaign. The broader conversation on politics has also spread in Canada and sparked increased viewership on topics of inflation, housing issues, debates, etc.",
  timeline: "August 2024",
  headerDesc: "Discussion on the political landscape has exponent...",
  primaryChannel: ["instagram","tiktok","linkedin","youtube"]
},{
  title: "In Beauty and Fashion: Demure & Mindful",
  description: 'Recently, Tiktoker Jooles Lebron went viral for their go-to-work beauty look; describing it to be very demure, and very mindful. According to the TikToker, being demure is about being mindful of others and your environment, and appropriate with your actions. This trend has since widely spread across social media with people sharing their thoughts on being demure and mindful: 1. There is an exponential growth in creators sharing their #demure fashion/beauty looks, 2. There are discussion based videos on what it means for people, particularly women to be demure and mindful, and 3. Businesses are weighing in on being very demure and mindful, for example, “we don’t schedule 4 pm meetings on Fridays, we’re #demure and #mindful”.',
  timeline: "September 2024",
  headerDesc: "Recently, Tiktoker Jooles Lebron went viral for...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Brat Green & Brat Girl",
  description: "The Brat Green trend had taken over social media this summer, and is again rising in popularity moving into September. The Brat trend has sparked a movement, inspiring girls and women to unapologetically be themselves, and not be afraid of others' judgment - Tying to the larger topic of women’s empowerment. This trend began with the launch of Charli XCX’s album “Brat” and took over social media with Brat Green being the most trending colour, and the concept of being “brat” as hip, trendy, and cool. The music album has inspired thousands of posts on social media through dances, memes, and beauty/fashion trends, especially among young adults and teens. The song Apple from this album, has thousands of dance posts from creators, celebrities, and Olympic teams posting the trending dance. Phrases like “It's giving brat energy”, “brat girl”, and “brat summer/season” are now commonly used terms on social media - often about women and the overall “brat girl” aesthetic.",
  timeline: "September 2024",
  headerDesc: "The Brat Green trend had taken over social media this...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Back to School",
  description: "Back to school is one of the hottest topics on social this month, with students and parents sharing their back-to-school essentials, outfits, meal prep, and more. With school season starting this week, topics around back-to-school are top on the trending list. Comedic posts surrounding back-to-school have been trending at this time, as well as teacher-focused content, student recipes, and study tips/hacks are trending. Broader topics on education and student parenting tips are also trending.",
  timeline: "September 2024",
  headerDesc: "Back to school is one of the hottest topics on social...",
  primaryChannel: ["instagram","tiktok", "youtube"]
},
{
  title: "Generational Gaps",
  description: "Numerous posts are trending on the major language and lifestyle gaps between Gen Alpha, GenZ/Millenial versus the older generations. There are now trending posts around the new language slang among GenZ, and particularly Gen Alpha, which are almost incomprehensible for most older generations. The majority of these posts are comedic in nature. Businesses have also tapped into this trend with posts surrounding GenZ versus Millenial and Older workers. There is also a more serious side to this trend with many content creators discussing the opportunities, and cost of living differentiators between the GenZ/Millenial generation, versus the older generations. There is also a growing discussion of the need for better workplace culture, with GenZ valuing mental health and work-life balance as a priority in their work environment.",
  timeline: "September 2024",
  headerDesc: "Numerous posts are trending on the major language and...",
  primaryChannel: ["instagram","tiktok","youtube","linkedin"]
},
{
  title: "Dopamine Menu",
  description: 'The new trend Dopamine Menu, has gone viral across social media, particularly on Instagram and TikTok. This trend focuses on people sharing what makes them the happiest (gives them increased dopamine). This trend has expanded to a point where many now use the term dopamine menu in common conversation. Ex: “What’s on your dopamine menu?”, “Walks on the beach are high on my dopamine menu.” The main focus of this trend is showcasing lists of things that make you happy. Often showcased in reel or carousel format. Brands have also tapped into this trend through influencer marketing, where creators show which products and brands they cant live without as part of their dopamine menu. See more <a href="https://www.tiktok.com/tag/dopaminemenu" traget="blank">example here</a>',
  timeline: "September 2024",
  headerDesc: "The new trend Dopamine Menu, has gone viral across...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "What’s In My Bag",
  description: '“What’s in my bag” is a trending topic primarily among women, showing what’s in their bags. The trend centers around your aesthetic and what you carry in your purse/bag - many creators are showcasing their aesthetic beauty products, and daily essentials. This trend also builds off the demure trend, and being demure and mindful about whats in your purse. The trend also showcases what type of girl/women they are based on what they carry. The content is primarily in reel or carousel format with the text overlay “what’s in my bag”',
  timeline: "September 2024",
  headerDesc: '“What’s in my bag” is a trending topic primarily...',
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Business Trend: My Gen Z Marketing Team",
  description: 'Building off the Generational gaps trend, businesses have been going viral with their GenZ marketing content. Hotels are claiming their rooms “slay”, real estate agents say their homes are “giving vibes” etc. These videos showcase how GenZ would market their brands with GenZ slang. This content has exponentially grown in viewership, engagement, and converted to increased account followership. This content aims to engage with the GenZ population on social media, primarily across Instagram and Tiktok. A great way to tap into this trend is to showcase how GenZ would market your company, brand, or narrative using a script filled with GenZ slang. Commonly these videos have a text overlay saying “my GenZ employee wrote our script” or “We asked our GenZ employee to create a promo video” etc. See an example of a <a href="https://www.tiktok.com/@fyfieldmanor/video/7409716301087722784?_r=1&_t=8pZvLM8haYj" target="blank">viral video here</a>',
  timeline: "September 2024",
  headerDesc: "Building off the Generational gaps trend, busine...",
  primaryChannel: ["instagram","tiktok","youtube"]
},
{
  title: "In Politics: Presidential Campaigns",
  description: "Discussion on the political landscape has exponentially grown in engagement and viewership this month. In particular, the US political landscape is a current hot topic on social, with many creators weighing in their thoughts on the Trump vs. Harris campaign. The recent US presidential debate has sparked the creation of thousands of videos with people sharing their views, thoughts on policy changes, and many comedic posts around key political statements. The broader conversation on politics has also spread and sparked increased viewership on topics of inflation, affordability, and immigration.",
  timeline: "September 2024",
  headerDesc: "Discussion on the political landscape has expone...",
  primaryChannel: ["instagram","tiktok","linkedin"]
},
{
  title: "Animal Focus: Moo Deng and Pesto",
  description: 'Moo Deng and Pesto have token over the Internet by storm. The latest trending topic on social media is the IT girl, Moo Deng, a baby pygmy hippo from Khao Kheow Open Zoo in Thailand. Moo Deng has become famous for her cuteness and sassy personality, with videos gaining millions of views across TikTok, Instagram and YouTube. Thousands of videos have been made about MooDeng, like "what kind of Moo Deng personality are you?" beauty routines with the "Moo Deng Makeup" and "Moo Deng Blush" Trend, among many others. Another baby that has gained celebrity status on social is the IT Boy, Pesto the Penguin. The baby penguin from Australia has become famous on social media for being one of the largest and heaviest penguins. Many videos about Pesto feature sibling/parent/family comedy content, and many creators have posted Pesto inspired outfits, recipes and more.',
  timeline: "October 2024",
  headerDesc: "Moo Deng and Pesto have token over the Internet...",
  primaryChannel: ["instagram","tiktok", "youtube"]
},
{
  title: "In Home and Garden: Cozy Season",
  description: "The cozy season of social is upon us, and there are now over 100K videos made on TikTok alone with the hasthags #fallvibes and #cozyseason. All things from cozy home design, comfort food, and cozy fall outfits are trending. Peope are looking for inspiration as they enter the fall season on things to buy and ways prepare for the season. Brands are tapping into this by ushering from summer fun content to more fall and winter themes.",
  timeline: "October 2024",
  headerDesc: "The cozy season of social is upon us, and there...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Do You Know You Have 30 Minutes?!",
  description: 'With over 200K videos made, content made with <a href="https://www.tiktok.com/@seanmperry_/video/7402359279778401578" target="blank">this audio</a> is going viral across Instagram and TikTok. Content creators are using this audio to share educational and comedic content around any topic that is time sensitive. Use this audio to share key time sensitive action items with your audience. For example, limited time offers, early birds, or new product launches.',
  timeline: "October 2024",
  headerDesc: "With over 200K videos made, content made with...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "This and Yap",
  description: 'This and Yap, is a trending topic accorss Instagram and TikTok. Creators are sharing their favorite places to be/things to do, accompanied with "Yap" (which means to chat, talk or gossip). This trend has gone so viral that many GenZ now use this statement in common language conversation. For example being on a beach and saying "nothing better than this and yap". Brands have also tappend into this trend by showing some of their favorite products, brand experiences, events and "Yap". See an <a href="https://www.tiktok.com/@seanmperry_/video/7402359279778401578" target="blank"></a>',
  timeline: "October 2024",
  headerDesc: "This and Yap, is a trending topic accorss Insta...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Brand Feature: Nutter Butter ",
  description: 'The Nutter Butter Social Media Account has sparked widespread commentary, criticism, and applause on TikTok. Nutter Butter recently went from a small account to over 1M followers on TikTok, and their strange and slightly eery TikTok brand marketing videos have been gaining millions of views. Numerous content creaotrs have taken to social media to talk about the Nutter Butter account theorizing the strategy and reasoning behind the companies new media strategy. This conversation has also spread from Tiktok to other channels like Instagram and LinkedIn among the marketing and creator community. The conversation has now balooned into the broader topic of what it means to be brand safe, and social-first. Many marketers and creators are stating that the account is "creative Genius" and "GenZ" as it has sparked such a massive response and followership.',
  timeline: "October 2024",
  headerDesc: "The Nutter Butter Social Media Account has spar...",
  primaryChannel: ["linkedin","tiktok"]
},
{
  title: "Halloween",
  description: "October is here and halloween is already on the top trending list. Before the halloween trending topic becomes saturated, its great to launch any halloween related content at the beginning of October. Halloween costumes, recipes, Harry Potter Themes and spooky design/decor are all trending this week.",
  timeline: "October 2024",
  headerDesc: "October is here and halloween is already on the...",
  primaryChannel: ["instagram","tiktok","youtube"]
},
{
  title: "Mental Health Spotlight",
  description: "Mental health is a trending topic this month. World mental health day has sparked increased discussion and content around topics of mental health, combatting stress, and the importance of a positive community/mindset. World mental health day has also sparked thousands of comedic posts around mental health and how people have learned to live with their heavy stress on a daily basis. Many brands are sharing their positive view points on mental health, and the need for awareness. The next two weeks are great to shed light on the topic of mental health.",
  timeline: "October 2024",
  headerDesc: "Mental health is a trending topic this month...",
  primaryChannel: ["instagram","tiktok","youtube"]
},
{
  title: "In the Klerb, we all fam.",
  description: 'With over 70K videos in under a week, <a href="https://www.tiktok.com/music/original-sound-7421694865471327007" target="blank">this sound</a> is going viral on Tiktok. Use this audio to share a topic in which something you are sharing just isn’t being understood. Majority of these posts are comedic in nature, and from a brand perspective you can use this audio to share your product/brand benefits that many people may not know about.',
  timeline: "October 2024",
  headerDesc: "With over 70K videos in under a week, this sound...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Humans saw this and then created ...",
  description: 'Use <a href="https://www.tiktok.com/discover/humans-saw-this-and-decided-to-create" target="blank">this trend </a> to show an amazing natural lansdcape and then something people invested thats very techy, boring, or constricting. For example, showing a beautiful beach with the text onscreen saying "humans saw this and created Excel, C++, Math, Wage Gaps etc."',
  timeline: "October 2024",
  headerDesc: "Use this trend to show an amazing natural natural lansd...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "In Health: Spotlight on Men's Health",
  description: "Health awareness topics are trending this month as November is a key month for driving awareness of mens health, diabetes and lung cancer. Content surrounding education of these topics are trending as creators shed light and their thoughts on health/wellness.  Movember is especially a trending topic on social as many male creators are growing their mustache in support of mens health awareness. This month is a good time for brands to post educational and awareness content around key health issues.",
  timeline: "November 2024",
  headerDesc: "Health awareness topics are trending this month as November...",
  primaryChannel: ["instagram","tiktok", "youtube", "linkedin"]
},
{
  title: "In Politics: U.S. Presidential ELections",
  description: "Discussion on the political landscape has exponentially grown in engagement and viewership. In particular, the US political landscape is a current hot topic on social, with many creators weighing in their thoughts on the Trump vs. Harris campaign and final election results. Many creators are also weighing in on the policy changes that are projected to come into effect under the new government leaders. The broader conversation has increased viewership on topics of gender, women's rights, inflation and immigration.",
  timeline: "November 2024",
  headerDesc: "Discussion on the political landscape...",
  primaryChannel: ["instagram","tiktok", "linkedin", "youtube"]
},
{
  title: "That Sums Me Up",
  description: "This trend is most often used in carousel format, and its used to share something specific about you/or your brand, and the second carousel saying 'that basically sums me/us up'. This content is used to share more about your core values, and/or brand identity. The content can also be used to showcase comedic content by saying something funny or cliche about yourself, OR used to share how you are dealing with grief and how you overcame it.",
  timeline: "November 2024",
  headerDesc: "This trend is most often used in carousel format...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Add a Tip",
  description: "Tipping culture has become a big topic of conversation, and this trend brings a comedic angle to tipping. With over 150K posts on this trend and growing, this trend has high elvels of viewrship, engagement and virality. To hop onto this trend and boost engagement, brands and creators are sharing absurd ways to collect tips. ",
  timeline: "November 2024",
  headerDesc: "Tipping culture has become a big topic...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Camera Flip Trend",
  description: "The camera flip trend has gone viral across Tiktok and Instagram. The trend is used to share a topic/opinion and then the camera accidently flips on you to share your POV. Here is an example of how Taylor Lautner recently jumped on this trend, and his video received over 170 Million views. Many business/brand teams have also jumped onto this trend to share funny office videos. In the last week this trend is also going viral across Instagram. You can hop on this trend by creating a video sharing an opinion/view and then flip the camera to show your team. This content is typically comedic in nature.",
  timeline: "December 2024",
  headerDesc: "The camera flip trend has gone viral across...",
  primaryChannel: ["instagram","tiktok", "youtube"]
},
{
  title: "I Have an Announcement",
  description: "With over 30K posts, this trend is going viral on Instagram. Say you have an announcement, and share exciting news with your audience. This content is expecially trending with brands as they can use this audio to share exciting news about their products, holiday deals, or just share an exciting new brand offering. You can hop onto this trend to share any new resources, or programs being launched.",
  timeline: "December 2024",
  headerDesc: "With over 30K posts, this trend is going viral...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "We listen and we dont judge",
  description: "This trend is blowing up on Tiktok this month. The content is focused on being vulnerable and sharing secrets/thoughts without judgement. This trend is most popular among couples, however, you can do this trend with anyone (your friends, team, family etc). You can hop on this trend by bringing a few people together to share your thoughts and you can only listen, without sharing any judgement. This content is currently high in engagement and viewership, and a great way to stay relevent on trends.",
  timeline: "December 2024",
  headerDesc: "This trend is blowing up on Tiktok this month...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "Women in Male Fields",
  description: "This is a growing trend across Tiktok to show the power of women and how they are truly dominating in traditionally male dominated fields. Use this trend to share some appreciation for the amazing women in your life that are crushing it.",
  timeline: "December 2024",
  headerDesc: "This is a growing trend across Tiktok to show the power...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "New Year, New Me: 2025 Resolutions and Healthy Lifestyle Changes",
  description: "With the new year, comes new resolutions. Share your 2025 resolutions with your community and how you plan on changing and improving yourself this year. Many creators are sharing their ideal new selves, new clothing styles and new healthy lifestyles that they plan on bringing to life in 2025. To hop on this trend, you can share some of the big brand changes your are bringing to life in 2025. This month there is a highlight on content focusing on healthy workout routines, healthy recipes, new beauty and fashion styles, and investing/monetization stategies to build income. This is a great time to share how your brand/products can improve the lives of your consumers this year. ",
  timeline: "January 2025",
  headerDesc: "With the new year, comes new resolutions. Share your...",
  primaryChannel: ["instagram","tiktok", "youtube", "linkedin"]
},
{
  title: "I Love...",
  description: "Ease into the new year by sharing comforting videos of the things you love in life - It could be romanticizing your daily routine, your pets, or your family. This trend, using the song Chest Pain (I love) is gaining virality across Instagram and TikTok with high viewership and engagement. Create this trending video for your brand by share different clips of the things you love in a collage video format.",
  timeline: "January 2025",
  headerDesc: "Ease into the new year by sharing comforting videos of the things you...",
  primaryChannel: ["instagram","tiktok"]
},{
  title: "In Technology: 2025 Technology Innovation & Advancements",
  description: "LinkedIn and X community members are abuzz with comments, news, and thoughts on all the technological advancements and movements coming in 2025. With the Consumer Electronics Show kicking off the years latest tech advancements, there is high engagement for posts focused on new technologies and AI. January is packed with big technology conferences and big new changes from the worlds largest technology companies. Ride this trend by sharing your thoughts on some of the big shifts in technology and digital transformation in 2025.",
  timeline: "January 2025",
  headerDesc: "LinkedIn and X community members are abuzz with comments, news, and...",
  primaryChannel: ["linkedin"]
},{
  title: "I Make The Face, You Make The Sound",
  description: "This trend is focused on having fun with friends and family. The trend showcases one individual making a face on camera, and the other friend (off camera) voicing what that facil expression may sound like. It's a funny way to bring friends together and see their reactions. This trend has high engagement and focuses on being comedic and entertaining for viewers.",
  timeline: "January 2025",
  headerDesc: "This trend is focused on having fun with friends and family...",
  primaryChannel: ["instagram","tiktok"]
},
{
  title: "News on the Los Angeles Wildfires",
  description: "The news on the rapidly spreading wildfires in Los Angeles, California has sparked mass conversation across social media. Content surrounding the wildfires is top on the trending list - Communities on social are reacting to the devastation and finding ways to help displaced individuals.",
  timeline: "January 2025",
  headerDesc: "The news on the rapidly spreading wildfires in Los Angeles, California has...",
  primaryChannel: ["instagram","tiktok", "youtube", "linkedin"]
},
{
  title: "In Sports: Suberbowl",
  description: "The Superbowl is one of the top trending topics on social media across North America. Content focused on the big game are trending with a spotlight on game day outfits, recipes, and GRWM style content. Post super-bowl, the Kendrick Lamar and Sza halftime show has become one of the highest searched topics, with many sharing their reaction videos and comments on the performance and song selection.",
  timeline: "February 2025",
  headerDesc: "The Superbowl is one of the top trending topics on social media across North America...",
  primaryChannel: ["instagram","tiktok", "youtube", "linkedin"]
},
{
  title: "Peekaboo",
  description: "In the space of fashion and apparel, the peekaboo trend is one of the most recreated outfit trends this month. To jump on this trend, share your outfit inspiration videos with clothing change timing in sync with the popular kendrick lamar song, Peekaboo. ",
  timeline: "February 2025",
  headerDesc: "In the space of fashion and apparel, the peekaboo trend is one of the most recreated...",
  primaryChannel: ["instagram","tiktok",]
},
{
  title: "In Beauty: Trying Latina Makeup",
  description: "In the space of Beauty, the Latina makeup trend is driving increased viewership and engagement. The content is focused on individuals recreating the traditional Latina makeup style. To hop on this trend, you can share your beauty products that help you achieve a Latina glam makeup look.",
  timeline: "February 2025",
  headerDesc: "In the space of beauty, the Latina makeup trend is driving increased viewership...",
  primaryChannel: ["instagram","tiktok", "youtube", ]
},
{
  title: "In Technology: AI Industry & DeepSeek",
  description: "The conversation surrounding AI and DeepSeek has exploded across social channels. Many news channels are sharing how DeepSeek’s latest models, created by a small company with limited resources, are already beating some of the leading AI models in the United States. The launch of DeepSeek also impacted the stock markets particular for AI and technology stocks.  This has sparked numerous debates and conversations across social. Content sharing thoughts on the AI Industry and DeepSeek have seen higher engagement rates and vewership. ",
  timeline: "February 2025",
  headerDesc: "The conversation surrounding AI and DeepSeek has exploded across social channels. Many news channels...",
  primaryChannel: ["instagram","youtube", "linkedin"]
},
{
  title: "Valentine's Showcase",
  description: "This month, Valentine's Day is one of the top trending topics globally. Sharing content with Valentine's themes and inspiration are seeing boosted engagement as more people are looking for inspiration to celebrate their Valentine's. This is a great time to share content inspired by Valentine's Day. In particular, Valentine's fashion and beauty looks, date-night recipes, and Valentine's decor are trending. The topic of Galentines also trending, as many creators are coming together with their friends to host girls night with fun drinks, decor, and themes. ",
  timeline: "February 2025",
  headerDesc: "This month, Valentine's Day is one of the top trending topics globally. Sharing content with...",
  primaryChannel: ["instagram","tiktok", "youtube", ]
},
{
  title: "Lockjaw Trend",
  description: "This is one of the top trending content formats among creators this month, especially in the fashion and beauty space on TikTok and Instagram. In terms of the trend, Lockjaw means being speechless, stunned, or amazed in a manner where your jaw drops, and the content is focused on showcasing incredible makeovers or unrecognizable makeup looks with the popular lockjaw music audio. To recreate this trend simply share a before and after video clip.",
  timeline: "February 2025",
  headerDesc: "This is one of the top trending content formats among creators this month, especially in the fashion and...",
  primaryChannel: ["instagram","tiktok",]
},
{
  title: "Emergency Contact",
  description:"This trend is focused on having fun with friends and family. Showcase who your emergeny contact is, and all the silly things they do with mutiple clips. This trend has high engagement and viewership as viewers enjoy the comedic and relatable content. You can recreate this trend by sharing your emergency contact and all the embarassing and silly clips of them.",
  timeline: "March 2025",
  headerDesc: "This trend is focused on having fun with friends and family. Showcase who your emergeny contact is, and all...",
  primaryChannel: ["instagram","tiktok",]
},
{
  title: "In Fashion and Apparel: Sun vs. Moon",
  description:"The sun vs. moon trend is high on the trending list in the fashion and beauty space of social media. Creators are sharing whether a dark beauty/fashion/hair look suits them, versus a bright aesthetic. You can recreate this trend by sharing a carousel of two pictures with different aeethetics and let the audience choose the best one. As a brand you can jump on this trend by sharing the moon vs. sun aesthetic of your logo or products. ",
  timeline: "March 2025",
  headerDesc: "The sun vs. moon trend is high on the trending list in the fashion and beauty space of social media. Creators are...",
  primaryChannel: ["instagram","tiktok",]
},
{
  title: "Spring Is In The Air",
  description:"March is ushering in the spring era of content as the weather gets warmer. This is a perfect time to share spring outfit inspiration, beauty looks, home/garden tips, travel plans and more. March break signals a great time for family friendly travel and back to school content. For brands, this is the right time to start shifting your branding from a fall and winter focus into preparations for spring and summer. ",
  timeline: "March 2025",
  headerDesc: "March is ushering in the spring era of content as the weather gets warmer. This is a perfect time...",
  primaryChannel: ["instagram","tiktok","youtube"]
},
{
  title: "Anxiety Dance Trend",
  description:"The latest dance trend across social media is the Anxiety trend. You can recreate this trend by posting a video to the song Anxiety by Sleepy Hallow and Doechii, where one person is dancing with headphones on and another person comes in from behind them and does the same dance in sync. ",
  timeline: "March 2025",
  headerDesc: "The latest dance trend across social media is the Anxiety trend. You can recreate this trend by posting a video to the...",
  primaryChannel: ["instagram","tiktok","youtube"]
},
{
  title: "In Politics: Tariffs and Economic Uncertainty",
  description:"Conversations around tariffs and economic uncertainty are top on the trending list across the business and political communities on social. Stock markets are heavily impacted by the uncertainties of the economic and political situations. As a result, conversations around tariffs, their implications on industries and markets will be a focal point across channels this month.",
  timeline: "March 2025",
  headerDesc: "Conversations around tariffs and economic uncertainty are top on the trending list across the business and...",
  primaryChannel: ["linkedin", "instagram","tiktok","youtube"]
},
{
  title: "April Fools Fun",
  description: "Accross channels, communities are engaging with April Fool's content. Whether you are a brand or a creator, this is a perfect time to share fun April Fool's content.",
  timeline: "April 2025",
  headerDesc: "Accross channels, communities are engaging with April Fool's content. Whether you are a brand...",
  primaryChannel: ["linkedin", "instagram","tiktok","youtube"]
},
{
  title: "The Cookie Test: Family Fun",
  description: "This trend is bringing families around the world together to see if their child would share their cookie with someone that doesnt have one. This content is high on the trending list with increased engagement and view time. This trend has since expanded to see if team members, or friends would share their cookie with someone that doesnt have one. You can hop on this trend by getting two of your team members and testing one of them.",
  timeline: "April 2025",
  headerDesc: "Family's are coming together to test their kids with the cookie test. This trend is bringing families ...",
  primaryChannel: ["tiktok", "instagram", "youtube"]
},
{
  title: "In Fashion and Apparel: Spring OOTD",
  description: "As we usher into Spring season, it's time to showcase your best spring fashion looks and outfits of the day. Spring fashion inspo is high on the trending list as people look for inspiration on the latest fashion trends of the season. As part of this trend we are also seeing an uptick in spring work outfit inspiration.",
  timeline: "April 2025",
  headerDesc: "As we usher into Spring season, it's time to showcase your best spring fashion looks and outfits of the ...",
  primaryChannel: ["tiktok", "instagram", "youtube"]
},
{
  title: "Unhinged",
  description: "People are coming to social media asking their community to share the most unhinged experiences, advice, life hacks etc. You can recreate this trend by posting a video or picture with a text overlay asking people for their most unhinged tips/advice for anything.",
  timeline: "April 2025",
  headerDesc: "People are coming to social media asking their community to share the most unhinged experiences, advice...",
  primaryChannel: ["tiktok", "instagram",]
},
{
  title: "Warm Trend",
  description: "With over 50K posts, this new trend is driving increased engagement and viewership with audiences on TikTok and Instagram. This trend focus on positivity, personal growth and sharing joy with family and community. This content features the audio Warm by Ariana Grande. To recreate this trend, show audiences how amazing you are and how you enjoy sharing time with your community.",
  timeline: "April 2025",
  headerDesc: "With over 50K posts, this new trend is driving increased engagement and viewership with audiences on TikTok and ...",
  primaryChannel: ["tiktok", "instagram",]
},
{
  title: "In Politics: Financial Uncertainty and Tariffs",
  description: "This month communities are growing increasingly anxious over the economic uncertainty brought by tariffs. There is high viewrship, discussion and engagement on posts focusing on economic crises, stock markets, US political landscpae, and tariffs. Many creators in the business and financial industries are speaking on the challenges in the stock market, how to protect your finances, and implications of tariffs on global markets.",
  timeline: "April 2025",
  headerDesc: "This month communities are growing increasingly anxious over the economic uncertainty brought by tariffs. There is...",
  primaryChannel: ["instagram", "linkedin", "tiktok", "youtube"]
},
{
  title: "Dance Trend: Shake It To The Max",
  description:"With over 140k posts in under two weeks, this dance trend is taking off on TikTok and YouTube. Creators are bringing their friends together to try the viral dance trend paired with the song Shake It To The Max by Moliy.",
  timeline: "April 2025",
  headerDesc: "With over 140k posts in under two weeks, this dance trend is taking off on TikTok and YouTube. Creators are...",
  primaryChannel: ["tiktok", "youtube"]
},
{
  title: "100 Men Vs. 1 Gorilla",
  description:"This debate has sparked widespread debate across TikTok, Instagram and Youtube, with audiences sharing their thoughts on who they think would win in a battle between 1 gorilla and 100 men. There are thousands of posts with people sharing who they they think would win and why. There is also a comedic side of this trend, where people are prank calling their friends/relatives saying they were signed up for a new reality show to fight a gorilla. Content around this debate has high engagement and virality score. ",
  timeline: "May 2025",
  headerDesc: "This debate has sparked widespread conversation and content across TikTok, Instagram and Youtube, with audiences...",
  primaryChannel: ["instagram", "tiktok", "youtube"]
},
{
  title: "So Hungry I Could Eat...",
  description:"You can recreate this trend by posting a video showing someone’s reaction when you say “I’m so hungry I could eat a [insert name of random person they know that you shouldn’t know about”]. This content is primarily focusing on family fun, but there is also growing popularity to share a reaction video of your boss/team member when you bring this up. You can recreate this trend with your family, friends, or team members. ",
  timeline: "May 2025",
  headerDesc: "You can recreate this trend by Posting a video showing someone’s reaction...",
  primaryChannel: ["instagram", "tiktok", "youtube"]
},
{
  title: "The Butterfly Effect",
  description:"Creators are reflecting on how certain aspects of their lives have changed because of something they did in the past. Ex: 'The butterfly effect is crazy because what if I hadn't.....' Share your successes and reflect on where you started from with this inspiring trend. ",
  timeline: "May 2025",
  headerDesc: "Creators are reflecting on how certain aspects of their lives have changed because... ",
  primaryChannel: ["instagram", "tiktok"]
},
{
  title: "Noooo",
  description:"With almost ten thousand posts under this viral audio. You can recreate this trend by sharing something you really don't like/don't want to do that may be fun for others.",
  timeline: "May 2025",
  headerDesc: "With almost ten thousand posts under this viral audio. You can recreate this trend by sharing something you",
  primaryChannel: ["instagram"]
},
{
  title: "In Politics: U.S. Visit To Saudi Arabia",
  description:"Top on the trending list is US President Trump's visit to Saudi Arabia. There are thousands of posts on the political discussions, partnerships, and outcomes of this visit. Many are also discussing the increased investments into artificial intelligence and defence industries. ",
  timeline: "May 2025",
  headerDesc: "Top on the trending list is US President Trump's visit to Saudi Arabia. There are thousands",
  primaryChannel: ["linkedin", "instagram", "tiktok", "youtube"]
},
{
  title: "Holy Effing Airball",
  description:"This trend refers to the basketball sports term airball - a shot that misses the hoop. This trend is used to share a case where somebody may have misunderstood or underestimated you in the first clip, and then how you are an expert or super accomplished in that field. For example 'I told them I have a beauty brand.. they said oh are you making fun lip colors?... holy effing airball... I founded a multi million dollar beauty company.' You can recreate this with your own brand to share your brand or product story.",
  timeline: "June 2025",
  headerDesc: "This trend refers to the basketball sports term airball - a shot that misses the hoop. This trend is used... ",
  primaryChannel: [ "instagram", "tiktok", ]
},{
  title: "ChatGPT Wrote This Reel",
  description:" Creators are asking ChatGPT to write them a funny script or reel skit. Creators then enact them to make funny and awkward content. For brands you can ask ChatGPT to create a brand ad or commerical and show your own recreation. This content has a high engagement rate since the overall conversation around AI generated content is trending. ",
  timeline: "June 2025",
  headerDesc: "Creators are asking ChatGPT to write them a funny script or reel skit. Creators then enact them to make",
  primaryChannel: [ "instagram", "youtube"]
},{
  title: "Match Your Words To The Beat",
  description:"Instead of speaking or singing, creators are sharing their opinions/POVs of what they believe the song sounds like to them with text overlay. This content is short, relatable, and can be easily personalized. For brands, you can match the beat and share customer thoughts, product features, or brand messaging,",
  timeline: "June 2025",
  headerDesc: "Instead of speaking or singing, creators are sharing their opions/POVs of what they believe...",
  primaryChannel: [ "instagram", "tiktok", ]
},
{
  title: "In Technology: AI Generated Content",
  description:"The conversations around AI generated content and video are high on the trending list across channels. As AI is pushing the boundaries of video creation, many people are beginning to test how well AI can take their ideas and create full videos with matching audio and visuals. Several tech giants have recently launched new AI capabilities for content creation and this has sparked mass conversation on the differences between AI vs. human generated content. For brands you can share what AI generated content looks like for your brand or share the value of the incredible team behind your work.",
  timeline: "June 2025",
  headerDesc: "The conversations around AI generated content and video are high on the trending list across channels...",
  primaryChannel: [ "instagram", "tiktok", "linkedin", "youtube",]
},
{
  title: "In Travel & Tourism: Jet 2 Holiday",
  description:"This trend has gone completely viral across all social channels, focusing on the tourism and travel industry. In this trend people are sharing there most funny, crazy, embarrasing and unbelievable travel experiences. The audio of this trend uses the commercial audio 'Nothing Beats a Jet 2 Holiday'. This trend has also of offshooted into creators simply sharing embarrasing and funny moments in their lives (not necessarily travel related). You can hop on this trend by sharing something funny or comical in your travel vlogs, or in your day to day life. This content has high viewership and engagement rates.",
  timeline: "July 2025",
  headerDesc: "This trend has gone completely viral across all social channels, focusing on the tourism and travel...",
  primaryChannel: [ "instagram", "tiktok", "linkedin", "youtube",]
},
{
  title: "I Grieve Different",
  description:"This trend is going viral across Instagram and TikTok. The format is most commonly shared in a 2 picture carousel post: In the first image you share something amazing, and the second image share something that isnt that great but accompanies the amazing thing. For example: Share how you love to cook in the first picture, and share how you dont like the dishes that come with it in the following picture. You have a lot of flexibility with this trend as it can encompass any topic. The most viral videos in this trend are often highly relatable and comical.",
  timeline: "July 2025",
  headerDesc: "This trend is going viral accross Instagram and TikTok. The format is most commonly shared in a 2 picture...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},{
  title: "In Sports: 2025 Wimbeldon",
  description:"The Wimbeldon is top on the trending list in sports. As a result content around tennis, learning tennis, tennis apparel, and Wimbeldon match highlights are all trending. Many creators are also commenting on the celebrity fashion styles being spotted at Wimbeldon this year. This has sparked a fashion and apparel trend of outfits that are inspired by Wimbeldon looks.",
  timeline: "July 2025",
  headerDesc: "The Wimbeldon is top on the trending list in sports. As a result content around tennis, learning",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Beauty and Apparel: Summer Looks",
  description:"Summer is in full swing and so are the fashion and beauty trends focusing on THE summer look. Creators are sharing their favorite cute summer fashion outfits of the day and beauty looks inspired by popular summer colors. This is a perfect time to showcase your brand and the summer looks your are most excited about. A secondary trend in the beauty and apparel space this month is the 'Unrecognizable Look' trend where creators are showing their makeovers that make them almost unrecognizable. To recreate this trend show yourself without makeup or in a simple outfit, and then a complete glam makeover showing your style.",
  timeline: "July 2025",
  headerDesc: "Summer is in full swing and so are the fashion and beauty trends focusing on THE summer look. Creators are...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Food and Beverage: Summer Drinks and Healthy Recipes",
  description:"In peak summer season, audiences are looking for new recipes to cool down and stay fit/healthy. This is a perfect time to showcase a summer drink series for people to enjoy and share with friends and family. Cocktais and mocktail recipes are especially high in viewership and engagement. Similarly, healthy recipes are high on the trending list with high-protein and low-calorie meals having increased virality.",
  timeline: "July 2025",
  headerDesc: "In peak summer season, audeinces are looking for new recipes to cool down and stay...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Fashion and Apparel: 'Throwing a Fit'",
  description:"In this trend, to throw a fit means to share your outfit of the day. Audiences are sharing how they, their friends, siblings, or spouses are late because they are 'throwing a fit' and then show up in an amazing outfit. For fashion and apparel brands this is a perfect trend to share your new merchandise, products, or upcoming Fall outfit inspiration. This video has a high view time and engagement rate, especially on Instagram and TikTok.",
  timeline: "August 2025",
  headerDesc: "In this trend, to throw a fit means to share your outfit of the day. Audiences are sharing...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Food and Beverage: Entering Cozy Season",
  description:"With upcoming seasonal change, people are shifting interests for healthy summer body recipes into cozy confort cooking season. This is a great time to share how your brand is the perfect addition to a comfort meal or dinner routine. Harvest season content is also trending, with people sharing the bounty of fresh vegetables from their home gardens. ",
  timeline: "August 2025",
  headerDesc: "With upcoming seasonal change, people are shifting interests for healthy summer...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Business, Retail, and Education: Back To School Season",
  description:"Back to school season is in full swing! From back to school supply hauls, dorm room decor, school outfit inspo, content centered around back to school season is trending for youth and parents across social media. For brands, this is a great time to highlight your back to school products, messaging, or stories to build your community.",
  timeline: "August 2025",
  headerDesc: "Back to school season is in full swing! From back to school supply hauls, dorm room decor, school outfit...",
  primaryChannel: [ "instagram", "tiktok", "youtube", "linkedin"]
},{
  title: "High Heels",
  description:"We hope you have great balance for this hot trend that has taken over Instagram, TikTok, and YouTube! Inspired by Nicki Minaj, in this trend people are sharing how they can balance on any object with one foot in high heels. Brands have jumped on this trend gaining mass virality by their teams standing on their products as a showcase of their product and team skill. This comedic trend is a great way to bring your brand to more audiences and build community/followership.",
  timeline: "August 2025",
  headerDesc: "We hope you have great balance for this hot trend that has taken over Instagram, TikTok,...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Lifestyle: I Know Ball",
  description: "This trend is a great way to showcase your strengths, and it's gaining virality across Instagram and TikTok. Post a three photo carousel showcasing something that you or your brand that you or your brand is very good at, but a lot of people don’t expect or know this. In the first photo add a text overlay explaining that people don’t think you know ball because of [blank], the middle photo being a filler photo with a “…”, then a final photo showing you excelling at the activity/skill, with the text “but I know ball”.",
  timeline: "September 2025",
  headerDesc: "This trend is a great way to showcase your strengths, and it's gaining virality across Instagram and TikTok. Post a three...",
  primaryChannel: [ "instagram", "tiktok",]
},
{
  title: "In Food and Beverage: Cozy Season and Comfort Food",
  description: "With the weather cooling and fall season arriving in full swing, audiences are seeking comforting and cozy recipes. Montage videos of comforting foods are also trending across channels with higher engagement.",
  timeline: "September 2025",
  headerDesc: "With the weather cooling and fall season arriving in full swing, audiences are seeking comforting ...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Beauty and Fashion: Fall and Office OOTD",
  description: "Summer fashion is out, and fall fashion is in. Fashion and beauty inspiration for the fall season is high on the trending list. Creators are sharing their best fall fashion tips, accessorization, and makeup routines for the fall season. As a subcategory, work fashion for the fall season is also trending, and this is a great opportunity to showcase what you or your team are wearing to the office this fall season.",
  timeline: "September 2025",
  headerDesc: "Summer fashion is out, and fall fashion is in. Fashion and beauty inspiration for the fall season...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Lifestyle: Unfortunately I Do Love",
  description: "This is a simple trend to unapoligetically share the things you love - this could be your guilty pleasures or unexpected likes and aspirations. To recreate this trend use a 5-8 second video, and add the text overlay 'unfortunately I do love' and then list all the things you love. To recreate this trend for you brand, you can share all the things you love about your product, team, or your brand mission.",
  timeline: "September 2025",
  headerDesc: "This is a simple trend to unapoligetically share the things you love - this could be your guilty pleasures or...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Lifestyle: [Blank]aholic",
  description: "In this trend, creators are sharing what they are obsessed with. For example stating that you are a 'Sisteraholic', 'Overthinkingaholic', 'Croissantaholic' etc. This content has a high engagement and share rate as it's very relatable content. To recreate this trend, you can share a video of something you are obsessed with, with the text overlay '_____aholic'.",
  timeline: "September 2025",
  headerDesc: "In this trend, creators are sharing what they are obsessed with. For example stating that you are a...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},

{
  title: "In Business: Gap and American Eagle Ad Campaigns",
  description: "This month the American Eagle and Gap ad campaigns have broke the internet with millions of impressions and conversations globally across channels. From LinkedIn, with thought leaders weighing in, to thousands of conversations on TikTok, these ad campaigns have gained mass virality.",
  timeline: "September 2025",
  headerDesc: "This month the American Eagle and Gap ad campaigns have broke the internet with millions of impressions...",
  primaryChannel: [ "instagram", "tiktok", "youtube","linkedin"]
},
{
  title: "In Lifestyle: The Lion Does Not Concern Itself With _______",
  description:"This trend is blowing up this month across Instagram and TikTok, with creators sharing things that they don't concern themselves with. You can easily recreate this trend by sharing something you are not bothered by with text overlay 'The Lion doesnt concern itself with X'. You can make this trend funny, motivational, etc. ",
  timeline: "October 2025",
  headerDesc: "This trend is blowing up this month across Instagram and TikTok, with creators sharing things that...",
  primaryChannel: [ "instagram", "tiktok", "youtube","linkedin"]
},
{
  title: "Across Industries Food, Beauty, Lifestyle: Spooky Season Trends",
  description:"Spooky season is here! With Halloween around the corner, trends around Halloween costume inspiration, halloween inspired recipes, decorations, beauty looks, and more are top on the trending list. This is a great time for your brand to create Halloween inspired content for your products, or show how your team has showed up to work in costume. This month, Halloween inspired content has higher viewership and engagement rates.",
  timeline: "October 2025",
  headerDesc: "Spooky season is here! With Halloween around the corner, trends around Halloween costum...",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "In Entertainment: The Life Of A Showgirl",
  description:"Taylor Swift recently launched a new album titled 'The Life Of A Showgirl' and it has taken social media by storm! Hundreds of thousands of posts have been made using the songs from this album, with notable increase in engagement. The top dance trend this month is also recreating Taylor Swift's music video dance routine. The album overall has recieved a lot of praise and backlash with communities sharing their thoughts on this latest album. ",
  timeline: "October 2025",
  headerDesc: "Taylor Swift recently launched a new album titled 'The Life Of A Showgirl' and it has taken social...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Lifestyle: 'Sometimes You Just Have To Read Your [insert person]’s Texts'",
  description: "Post a carousel to this sound where you show a funny or absurd text you received from a loved one or a colleague, with the first slide showing a photo of you and a text overlay saying “Sometimes you just gotta read your [insert person]’s texts and go about your day”, and the second slide showing the funny text. This content is easily recreatable and has high engagement, especially on TikTok.",
  timeline: "November 2025",
  headerDesc: "Post a carousel to this sound where you show a funny or absurd text you receive...",
  primaryChannel: [ "instagram", "tiktok", ]
},
{
  title: "In Beauty: Dinner Is Served",
  description: "In this trend, creators are serving up their must have, favorite beauty products. To recreate this trend, share your dinner plate packed with your beauty product essentials, with the on screen text 'Dinner is Served'. As a brand, this is an easy way to share some of your best selling products. ",
  timeline: "November 2025",
  headerDesc: "In this trend, creators are serving up their must have, favorite beauty products...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Fashion and Apparel: Let's See What [Insert Name] is Wearing Today",
  description: "In this trend, showcase your best outfit of the day from head to toe. Creators are showing their outfits, where they got it from, and how they are accessorizing to level-up their fits. As a brand, you can recreate this trend by sharing some outfit of the day inspiration from your latest collection, with the on-screen text and voiceover opening 'Let's See What [Insert Name] is Wearing Today' - then show your style from different angles.",
  timeline: "November 2025",
  headerDesc: "In this trend, showcase your best outfit of the day from head to toe. Creators are showing their...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Business and Technology: Is This An AI Bubble Or Not?",
  description: "AI and quantum computing companies are top on the conversation list with many thought leaders and communities debating whether or not we are in an AI bubble or if this is just the new era of technology. This conversation has sparked from the massive valuations and continued investment into AI and quantum companies. As a brand, this is a great time to share your initiatives or point of view on the AI Industry and it's trend forecast.  ",
  timeline: "November 2025",
  headerDesc: "AI and quantum computing companies are top on the conversation list with many thought...",
  primaryChannel: [ "instagram", "linkedin"]
},
{
  title: "In All Industries: Holiday Season",
  description: "The holidays are the largest content focus for this month. Content surrounding holiday recipes, decor, shopping/gifting, and family travel are all trending with increased viewership and engagement. This month content focused around the holiday season has higher traction and performance across all industries. From business perspective, this is a great time to share your holiday wishes to your customers and clients.",
  timeline: "December 2025",
  headerDesc: "The holidays are the largest content focus for this month. Content surrounding holiday recipes, decor...",
  primaryChannel: [ "instagram", "tiktok", "youtube", "linkedin"]
},
{
  title: "In Lifestyle: Turn The Lights Off",
  description: "This trend has taken off across TikTok, Instagram, and Youtube this month with hundreds of thousands of videos being created. To recreate this trend, share something that makes you feel amazing - For example 'POV: All Your Friday Meetings Get Cancelled' and the next clip being the viral clip of John Hamm with the trending audio Turn the Lights Off by Kato. The content leading this trend is often the most comedic or relatable, resulting in higher engagement and share count.",
  timeline: "December 2025",
  headerDesc: "This trend has taken off across TikTok, Instagram and Youtube this month with hundreds of thousands...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "2026 Predictions: New Year New Me",
  description: "Near the end of December, people are getting ready to reset and grow in 2026. Creators are sharing how they plan to evolve, change, and grow in 2026 with new mindset shifts that will help them be more successful. For example 'In 2026 we are ditching X and focusing on Y'. From a brand perspective, this is a perfect time to share you sneak peaks for 2026 or some of your industry predictions for the new year.",
  timeline: "December 2025",
  headerDesc: "Near the end of December, people are getting ready to reset and grow in 2026. Creators are sharing...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In Lifestyle and Beauty: Put Me In Chanel",
  description: "This has been the most viral dance trend and one of the most popular audios of December, using the audio 'Chanel' by the artist Tyla. To jump on this trend your team can recreate this short dance trend, or share content using this audio track for increased engagement and reach.",
  timeline: "December 2025",
  headerDesc: "This has been the most viral dance trend and one of the most popular audios of December, using...",
  primaryChannel: [ "instagram", "tiktok", "youtube",]
},
{
  title: "In All Industries: 2025 Wrapped",
  description: "December is a period of reflection to share your favorite and most memorable moments of 2025. To jump on this trend, share your brand's 2025 wrapped - most popular products, favorite brand moments, etc. From a B2B perspective, this is a great time to share some of the biggest product advacements this year, industry trends etc. This is often shared in a carousel format. ",
  timeline: "December 2025",
  headerDesc: "December is a period of reflection to share your favorite and most memorable moments of 2025. To jump on...",
  primaryChannel: [ "instagram", "tiktok", "youtube", "linkedin"]
},
{
  title: "In Lifestyle and Fashion: Back to 2016",
  description:"This trend is all about throwbacks. Share a 'Back to 2016' post by sharing pictures of you from that time. The trend is aimed at being wholesome, comedic, and relatable. These posts see a significant increase in engagement and you can easily recreate this trend for your brand. For example, you can share a throwback of your brand products/logo from 2016, or you can share your team's throwback pictures.",
  timeline: "January 2026",
  headerDesc:"This trend is all about throwbacks. Share a 'Back to 2016' post by sharing pictures of you from that time...",
  primaryChannel: [ "instagram", "tiktok", "youtube", ]
},
{
  title: "In Lifestyle: Whimsy",
  description:"This trend is all about making the ordinary more fun and whimsical. Creators are hopping on this trend to show the fun and whimsical parts of their day-to-day life. Content around 'how to make your life more whimsical', or 'daily whimsical habits' are trending, especially on Instagram, TikTok, and YouTube. You can recreate this trend for your brand by showing whimsical things about your product, team, or your brand story.",
  timeline: "January 2026",
  headerDesc:"This trend is all about making the ordinary more fun and whimsical. Creators are hopping on this...",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "New Year Resolutions",
  description:"The new year ushers in a period of new resolutions. Content surrounding dry January, healthy active living, weightloss, and career development are all seeing spikes in engagement across channels. To hop on this trend, your brand can share your goals/resolutions for 2026.",
  timeline: "January 2026",
  headerDesc:"The new year ushers in a period of new resolutions. Content surrounding  dry January, healthy active...",
  primaryChannel: [ "instagram", "tiktok", "youtube", "linkedin"]
},
{
  title: "Editing Life Like a TV Show",
  description:"In this comedic trend, creators are sharing their vlogs/lifestyle videos in the format of a reality TV show. The most engaging videos of this trend are often centered around group/family travel. To recreate this trend, you can film a day in the life at your office, and share dramatic clips and background music that make your day feel like a watch-worthy and entertaining reality tv show.",
  timeline: "January 2026",
  headerDesc:"In this comedic trend, creators are sharing their vlogs in the format of a reality TV show. The most engaging...",
  primaryChannel: [ "instagram", "tiktok", "youtube", "linkedin"]
},
{
  title: "Let Me Re-introduce Myself",
  description: "This trend is exactly how the title sounds. Creators are taking a moment to reintroduce themselves to their engaged community, new followers, and potential ones. With so much content on social media, this is a perfect way to remind your community about your brand, what you stand for, and why community is important to you!",
  headerDesc: "This trend is exactly how the title sounds. Creators are taking a moment to reintroduce themselves to their community...",
  timeline: "January 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "In Travel: Let’s See Where the Wind Takes Us",
  description: "Topics on vacation travel are trending this month, with a spike in vacations to escape the cold weather. To recreate this trend, start the video with the on-screen text, “Let’s see where the wind takes us”, filming at home or at the airport, and then fall into your new vacation destination. The video is very easy to recreate with a high engagement rate and watch-through rate as viewers wait for the ending reveal.",
  headerDesc: "Topics on vacation travel are trending this month, with a spike in vacations to escape the cold weather....",
  timeline: "February 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "In Lifestyle: “I Googled My Symptoms”",
  description: "With over 200K videos on Instagram alone, this trend is a great one to hop on. To recreate this trend, add on-screen text “Googled my symptoms and turns out… I just needed this”. The content is aimed at showcasing this people love, for example, I googled my symptoms, and it turns out I just needed a coffee, a home renovation, or a vacation etc. Add the on-screen text, build the suspense, then reveal your product or service.",
  headerDesc: "With over 200K videos on Instagram alone, this trend is a great one to hop on. To recreate this trend, add on-screen...",
  timeline: "February 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},{
  title: "In Lifestyle: The Ultimate Trio",
  description: "Paired with the background music “I Love Rock and Roll” this content is high on the trending list. The video features 3 different POVs that bring together the ultimate trio of friends, work buddies, team mates etc. To recreate this trend, you can share your ultimate work trio and your points of view on a certain product. ",
  headerDesc: "Paired with the background music “I Love Rock and Roll” this content is high on the trending list. The video...",
  timeline: "February 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},{
  title: "In Sports: The Winter Olympics and Super Bowl",
  description: "The Winter Olympics are at the top of the trending list this month. Content surrounding sports, fandom, and watch parties has increased engagement and viewership. Similarly, the Super Bowl is another major sports moment happening this month, and creators are sharing how they are getting ready for game day. To hop on this trend, create content that is inspired by the Olympic sports, fandom, or family get-togethers to watch the big game.",
  headerDesc: "The Winter Olympics are at the top of the trending list this month. Content surrounding sports, fandom...",
  timeline: "February 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube", "linkedin"]
},
{
  title: "In Finance: Investing During Rising Global Tension",
  description: "With global tensions on the rise, conversations surrounding oil prices, stocks, and AI technology valuations are trending. Many are sharing their opinions and thoughts on the best investment decisions to make during periods of economic uncertainty and portfolio diversification as markets fluctuate. ",
  headerDesc: "With global tensions on the rise, conversations surrounding oil prices, stocks, and AI technology valuations ...",
  timeline: "March 2026",
  primaryChannel: [ "instagram", "youtube", "linkedin"]
},
{
  title: "In Beauty and Product: I Fell, But I Saved My…",
  description: "With over 50K videos already created over the past week, this is a fun and easy trend to hop on. To recreate this trend, act as though you have already fallen, but you saved your [insert product] from the fall. This content organically shows your love for certain products. For example, I fell, but saved my lip gloss, laptop, blush etc. from the fall. ",
  headerDesc: "With over 50K videos already created over the past week, this is a fun and easy trend to hop on. To recreate...",
  timeline: "March 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},{
  title: "In Lifestyle: The Ultimate Duo",
  description: "This trend is gaining virality across TikTok and Instagram with creators sharing their ultimate duos. For example, the ultimate duo could be a coffee and a sweet treat, or the perfect duo could be about work besties - one who likes to eat, and the other one who loves going out for lunch. This trend can easily be used to highlight your brand products or team.",
  headerDesc: "This trend is gaining virality across TikTok and Instagram with creators sharing their ultimate duos...",
  timeline: "March 2026",
  primaryChannel: [ "instagram", "tiktok",]
},
{
  title: "In Lifestyle: The 360 Dance",
  description:"With over 200K posts, this trend is taking off! The trend is inspired by the release of the latest Bridgerton tv show season, 360 shuffle dance song. Creators recreate the tiny ballroom-style dance move into normal daily moments like walking into work or going to pick up your groceries. This audio is also causing smaller creators to boost their viewership and engagement. You can recreate the shuffle dance trend with this audio, or simply use this audio in the background of your videos. ",
  headerDesc: "With over 200K posts, this trend is taking off! The trend is inspired by the release of the latest Bridgerton...",
  timeline: "March 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "In Events & Key Moments: Coachella 2026",
  description: "Coachella content is top on the trending list this month with brands and creators sharing their content, activations, and experiences at the iconic Coachella festival. To jump on this trend, share you thoughts on Coachella (music, outfits, foods, stays etc.) or how you can get ready! Create content with the trending audio 'Baby' by Justin Bieber.",
  headerDesc: "Coachella content is top on the trending list this month with brands and creators sharing their content, activations, and...",
  timeline: "April 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "In Lifestyle: Airpods Switch",
  description: "This trend is taking over Instagram and TikTok, and it's simple to reacreate. Two people bump into each other, swap AirPods by accident, and suddenly they’re listening the other person's song which encompasses their entire vibe, from fashion to personality. It’s a great way to share more about your personailty, vibe and music taste in an engaging format. This content has seen high view time across channels.",
  headerDesc: "This trend is taking over Instagram and TikTok, and it's simple to reacreate. Two people bump into each other...",
  timeline: "April 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "In Lifestyle and Beauty: Things I Find Chic",
  description: "This trend is filled with elevated hot takes. To recreate this trend simply share an organic video with your audience on random things you find cool/chic whether its products, things at work, or betweeen friends. This content has a high engagement rate as it sparks conversation, debate, and a lots of relatability.",
  headerDesc: "This trend is filled with elevated hot takes. To recreate this trend simply share an organic video with your audience...",
  timeline: "April 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "In Lifestyle: Me Without Happiness ",
  description: "This is a fun and easy trend where creators are sharing what brings them joy. To recreate this trend share two clips. The first clip shows you standing with nothing. The second clip shows you standing with what brings you happiness - could be a coffee, your favorite brand product, or your best friend. Simply add the on sreen text 'Me without happiness' and 'Me with happiness'.",
  headerDesc: "This is a fun and easy trend where creators are sharing what brings them joy. To recreate this trend share...",
  timeline: "April 2026",
  primaryChannel: [ "instagram", "tiktok",]
},
{
  title: "In Home and Garden: Get Ready For Patio Season!",
  description: "Spring is in the air and that means patio and gardening season is around the corner. Many DIY and home/garden creators are sharing how they are elevating their homes and patios to get ready for the upcoming summer season. From patio makeovers, to gardening tips, this is a perfect time to share how your audience can level up their space this spring.",
  headerDesc: "Spring is in the air and that means patio and gardening season is around the corner. Many DIY and home/garden ...",
  timeline: "April 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "In Fashion and Beauty: Expose Your Addiction",
  description: "In this trend, creators are exposing their addictions of their favorite products, from shoes, lip glosses, denims and more. The more relatable and chaotic the addiction, the more engagement the content receives. This is an easy trend to recreate and a great way to showcase your brand's favorite products, or your team's coffee addictions. To recreate this trend, ask your friend/partner/colleague about a product you are thinking of buying and then they expose that you already have so much!",
  headerDesc: "In this trend, creators are exposing their addictions of their favorite products, from shoes, lip glosses,...",
  timeline: "May 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "For Brands: AI Is Taking Our Jobs",
  description: "This is a funny viral trend among businesses on Instagram and TikTok. The discourse on AI taking jobs has taken a comedic turn with this trend: Businesses are filming themselves doing the most unglamorous or labour intensive parts of their job with the onscreen text saying 'AI is going to take your job', followed by a clip saying 'WHEN?!'. The trend is light, funny, and shows the value of the businesses work in an era where everyone is talking about AI's impact on jobs.",
  headerDesc: "This is a funny viral trend among businesses on Instagram and TikTok. The discourse on AI taking jobs has...",
  timeline: "May 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube"]
},
{
  title: "In Lifestyle: My Top 5 Horror Movies",
  description: "This trend is top on the trending list, with creators sharing their top 5 worst scenarios (but in a comedic and relatable sense). To recreate this trend, share a video clip with the on-screen text listing your top 5 horror movies, and all 5 are relatable things that you dont like. For example, all 5 topics could be about not having coffee all day, having full phone storage, or working in the office without your work bestie etc. You can have a lot of fun with this trend and the more relatable, the more trend-worthy. ",
  headerDesc: "This trend is top on the trending list, with creators sharing their top 5 worst scenarios (but in a comedic and...",
  timeline: "May 2026",
  primaryChannel: [ "instagram", "tiktok" ]
},
{
  title: "For Brands: Office Pilates",
  description: "Brands are going viral on TikTok for sharing their pilates moves from their office desk. Brand creators are turning their office equipment, space, chairs and other tools they find to create a hilarious makeshift pilates session in the office. This trend can take some commitment from office teams, but the results are hilarious, and many brands are trending on TikTok for their mid-day office workouts.",
  headerDesc: "Brands are going viral on TikTok for sharing their pilates moves from their office desk. Brand creators...",
  timeline: "May 2026",
  primaryChannel: [ "tiktok"]
},
{
  title: "In Lifestyle: Girl's Grip",
  description: "Why use a purse or make two trips when you have the girl grip. The 'girl grip' is the art of grabbing your entire life in one hand —  keys, phone, snacks, wallet, the works — balanced with the confidence of someone who has never once dropped anything. This is a perfect way for brands to share some of their best products in hand.",
  headerDesc: "Why use a purse or make two trips when you have the girl grip. The 'girl grip' is the art...",
  timeline: "June 2026",
  primaryChannel: [ "instagram", "tiktok" ]
},
{
  title: "In Food and Beverage: Jujutsu Kaisen",
  description: "This trend has taken over social media feeds across channels. In a group of friends or colleagues, the video individually shows each different group member in a rapid fire lineup, with the items they chose popping into their hands - it could be a drink choice, a snack, or a hero product. This trend is great for teams, brands, or any group that wants to show off their top picks/personalities in one clip. ",
  headerDesc: "This trend has taken over social media feeds across channels. In a group of friends or colleagues...",
  timeline: "June 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "For Brands: Don't post your work, post yourself working",
  description: "Instead of just sharing your products, go behind the scenes and share 'how' you showcase your products. Take the audience behind the camera into the studio, your production process, or your teamwork. This trend is helping communities connect more closely with your brand by showing the dedicated process and your team's hard work behind your products/services that most wouldn't normally see. To recreate this trend, simply share a compilation of the process behind your ad campaigns or teamwork etc. with the on-screen text 'Don't post your work, post yourself working'.",
  headerDesc: "Instead of just sharing your products, go behind the scenes and share 'how' you showcase your products. Take the...",
  timeline: "June 2026",
  primaryChannel: [ "instagram", "tiktok" ]
},{
  title: "In Beauty: My Top 10",
  description: "Creators are sharing their top 10 of anything and everything - it could be their favorite beauty products, kitchen must haves, fav coffee spots etc. To recreate this trend, use the trending audio of My Top 10 Countdown, and share your favorite products or office must haves. This is a simple trend that shares more about you with your community.",
  headerDesc: "Creators are sharing their top 10 of anything and everything - it could be their favorite beauty products...",
  timeline: "June 2026",
  primaryChannel: [ "instagram", "tiktok" ]
},
{
  title: "In Lifestyle: My Netflix Documentary",
  description: "In this trend, creators are sharing their main characteristics as a descriptor for their own netflix documentary. To recreate this trend, simply act like you're getting ready to sit in front of the camera, putting your mic on, with on-screen text 'Me getting ready for my netflix documentary [insert something about you]'. The descriptor can be something serious, or funny like 'being a coffee addict'. The intention of the content is to be relatable, fun, and to share more about yourself with your community. ",
  headerDesc: "In this trend, creators are sharing their main characteristics as a descriptor for their own...",
  timeline: "July 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},{
  title: "In Sports: FIFA and Wimbledon Season",
  description: "The FIFA world cup is being watched and celebrated around the world this month. This is the perfect time to share football/soccer inspired content with your community. From reaction videos, to getting together with friends and family to watch the game, share how your brand is celebrating this global moment. In other sports news, Wimbledon is top on the trending list! Everything from tennis training, attire, and preppy fashion inspo is gaining increased engagement and views.",
  headerDesc: "The FIFA world cup is being watched and celebrated around the world this month. This is the perfect...",
  timeline: "July 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube", "linkedin" ]
},{
  title: "In Travel: The Summer Schedule",
  description: "This is a fun way to share your ideal summer day. To recreate this trend share 4 videos in one frame with the time stamp. For example, video one could be 9am playing tennis, then 12pm grabbing lunch by the ocean, 3pm surfing, and 9pm watching an outdoor movie. Many travel creators are using this template to share their daily travel itineraries.",
  headerDesc: "This is a fun way to share your ideal summer day. To recreate this trend share 4 videos in one...",
  timeline: "July 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},{
  title: "In Lifestyle: How To Summon Me",
  description: "This trend is taking off on Instagram with creators sharing what products or things summon them - it could be a cup of matcha, a shopping haul, a delicious meal etc. To recreate this trend, simply show the product and then you popping into frame to grab the product. This is a great way to share your favorite brand products in an engaging format. ",
  headerDesc: "This trend is taking off on Instagram with creators sharing what products or things summon them - it could...",
  timeline: "July 2026",
  primaryChannel: [ "instagram", "tiktok", ]
},
{
  title: "In Lifestyle: My Interactive Calendar",
  description: "This is a fun way to share your daily routine with your community from a B2B and B2C perspective. To recreate this trend, actually show what your Google calendar looks like and then show the video of what you're doing at that time. For example your calendar could have 'make breakfast, join standup meeting, fly for a team offsite' and you will show all of those things in a montage style video. This is a great content format to show the behind the scenes work of your team.",
  headerDesc: "This is a fun way to share your daily routine with your community from a B2B and B2C perspective. To recreate...",
  timeline: "July 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "In Lifestyle: Things That Are Worth The Money",
  description: "Showcase your top list of things you think are absolutely worth the money. This trend is driving high engagement levels with creators sharing the top 5-10 things they buy/invest in that they believe are 100% worth it. This trend is a great way to showcase your top products/services and why they are worth every penny.",
  headerDesc: "Showcase your top list of things you think are absolutely worth the money. This trend is driving high...",
  timeline: "August 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "In Fashion: Walk and Stop",
  description: "This is a super simple trend to show off your outfit of the day. To recreate this trend simply walk and freeze, then the camera will show the full 360 view of your outfit with the on-screen text showing where all your outfit and accessory pieces are from.",
  headerDesc: "This is a super simple trend to show off your outfit of the day. To recreate this trend simply...",
  timeline: "August 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "In Food and Beverage: Meal Swap",
  description: "Enjoying time with friends and loved ones? Show how you enjoy sharing your meals with them so that the entire table can have a taste. To recreate this trend simply share multiple clips of you swapping your meal or drink with someone else. Many creators are using this trend to share their travel eats or favorite meals of the week.",
  headerDesc: "Enjoying time with friends and loved ones? Show how you enjoy sharing your meals with them so that the...",
  timeline: "August 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "In Lifestyle: Asking the Wrong Questions",
  description: "This comedic trend is top on the trending list across TikTok and Instagram. To recreate this trend, ask your boss or a family member/friend a question and record all their answers. In the final clip ask something completely different stating 'Asking my [insert person] what they would do if ...'. In a very viral example, a team asked their boss what they would do if an intruder tried to rob their store, and after filming all his rseponses, in the final clip they said they said 'Here's what our boss said he would do if an orphan child came to the store asking for food'. The trend has soared in virality and engagement with many small to medium sized brands and creators. ",
  headerDesc: "This comedic trend is top on the trending list across TikTok and Instagram. To recreate this trend...",
  timeline: "August 2026",
  primaryChannel: [ "instagram", "tiktok", ]
},
{
  title: "In Food and Beverage: Cozy Comfort Cooking and Back To School",
  description: "Cozy comfort cooking season is here! Comforting, hearty recipes are top on the trending list as the weather cools down and audiences look for more warm, cozy dishes. Back-to-school recipes are also gaining increased engagement as school resumes, and parents and students look for quick lunch recipes.",
  headerDesc: "Cozy comfort cooking season is here! Comforting, hearty recipes are top on the trending list as the ...",
  timeline: "September 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "In Beauty and Fashion: Fall OOTD",
  description: "Fall fashion is top on the trending list as the summer season winds down. Fashion creators are showing their take on the styles and trends for fall fashion with fur coats, turtlenecks, and stylish ensembles. 'Where I went, what I wore, what I ate' is a popular trend where creators are sharing three clips (one of where they went, two of their full outfit review, and three of what they ate) to naturally show their outfit on a day-to-day basis. In beauty, fall makeup looks are trending with warmer tones and bold fall looks. ",
  headerDesc: "Fall fashion is top on the trending list as the summer season winds down. Fashion creators are showing...",
  timeline: "September 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "In Lifestyle: The Saxophones Keep Getting Louder",
  description: "This trend is taking off across channels, primarily on TikTok, with creators sharing moments that keep getting worse or more embarrassing as time goes on (which is why the saxophones keep getting louder). In this trend, share a team or brand moment where something went wrong comedically, with the on-screen text 'The saxophones keep getting louder'. This is a fun trend to connect with your audience on a more organic level and on average, has high engagement rates.",
  headerDesc: "This trend is taking off across channels, primarily on TikTok, with creators sharing moments that keep...",
  timeline: "September 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},
{
  title: "For Brands: The Product and The Process",
  description: "In this trend, businesses on social media are sharing their product and the process behind making it. For example, the video could start with showing your cup of coffee and then say 'Let's Start' and share a montage of your process in making that product. This trend is a great way for brands to share their secret sauce behind their product, what makes your brand unique etc.",
  headerDesc: "In this trend, businesses on social media are sharing their product and the process behind making it....",
  timeline: "September 2026",
  primaryChannel: [ "instagram", "tiktok", ]
},
{
  title: "In Fashion: Daily Outfit Loading",
  description: "This trend is going viral across TikTok and Instagram. To recreate this trend, start your video in your pajamas at 0% and then progressively add to your outfit till you are 100% ready. Have the percentages written as on-screen text to show your 'Get Ready With Me' loading.",
  headerDesc: "This trend is going viral across TikTok and Instagram. To recreate this trend, start your video in your...",
  timeline: "October 2026",
  primaryChannel: [ "instagram", "tiktok", ]
},
{
  title: "In Lifestyle: I'm Getting Robbed",
  description: "This trend is high in engagement across channels. To recreate this trend show a video of you getting your bag robbed without a care in the world because you are too preoccupied with something that's more important. For example, you're posting a story, listening to your friends voice note, or shopping on a last minute store wide sale. This is a great way for brands to showcase an amazing sale or new product launch.",
  headerDesc: "This trend is high in engagement across channels. To recreate this trend show a video of you getting your...",
  timeline: "October 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube" ]
},{
  title: "Spooky Season",
  description: "Halloween is around the corner and content with Halloween themes are spiking in engagement and viewership. Halloween inspired recipes, DIY costumes and decor, things to do during Halloween etc. are trending across channels, especially on Instagram and TikTok. This is a great opportunity for brands to boost engagement by sharing content inspired by Halloween.",
  headerDesc: "Halloween is around the corner and content with Halloween themes are spiking in engagement and...",
  timeline: "October 2026",
  primaryChannel: [ "instagram", "tiktok", "youtube", ]
},
]

export const TOP_CREATORS = [{
  name:"kyliejenner",
  industry:"Beauty",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"selenagomez",
  industry:"Beauty",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"kimkardashian",
  industry:"Beauty",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"jamescharles",
  industry:"Beauty",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"huda",
  industry:"Beauty",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"jeffreestar",
  industry:"Beauty",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"nikkietutorials",
  industry:"Beauty",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"gordongram",
  industry:"Food & Bev",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"jamieoliver",
  industry:"Food & Bev",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"thepioneerwoman",
  industry:"Food & Bev",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"marthastewart",
  industry:"Food & Bev",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"turkuazkitchen",
  industry:"Food & Bev",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"halfbakedharvest",
  industry:"Food & Bev",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"plantyou",
  industry:"Food & Bev",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"thisisbillgates",
  industry:"Business & Technology",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"mkbhd",
  industry:"Business & Technology",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"unboxtherapy",
  industry:"Business & Technology",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"garyvee",
  industry:"Business & Technology",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"tonyrobbins",
  industry:"Business & Technology",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"richardbranson",
  industry:"Business & Technology",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"jeffbezos",
  industry:"Business & Technology",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"chiaraferragni",
  industry:"Fashion & Clothing",
  followers:"",
  posts:"",
  profileUrl:""
},
{
  name:"aimeesong",
  industry:"Fashion & Clothing",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"camilacoelho",
  industry:"Fashion & Clothing",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"avani",
  industry:"Fashion & Clothing",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"emmachamberlain",
  industry:"Fashion & Clothing",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"wolfiecindy",
  industry:"Fashion & Clothing",
  followers:"",
  posts:"",
  profileUrl:""
},{
  name:"mirandakerr",
  industry:"Fashion & Clothing",
  followers:"",
  posts:"",
  profileUrl:""
},

]

export const COUNTRIES = [
  "All",
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo, Democratic Republic of the",
  "Congo, Republic of the",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor (Timor-Leste)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "South Korea",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Macedonia (formerly Macedonia)",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];
